exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-7afe2098]{position:absolute;width:100%;height:100%;padding-top:185px;padding-bottom:40px;box-sizing:border-box;display:flex;flex-direction:column}.container__wrapper[data-v-7afe2098]{display:block;position:relative;flex-grow:1}@media (max-width:990px){.container[data-v-7afe2098]{padding-top:140px}}@media (max-width:768px){.container[data-v-7afe2098]{padding-top:120px}}@media screen and (max-width:990px) and (max-height:860px){.container[data-v-7afe2098]{padding-top:100px}}@media screen and (max-height:620px){.container[data-v-7afe2098]{padding-top:75px}}@media screen and (max-height:500px){.container[data-v-7afe2098]{padding-top:55px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7afe2098","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CenterContainer.vue
// module id = 59
// module chunks = 0